import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../styles/Profile.css';
import '../styles/Search.css';

const Search = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searched, setSearched] = useState(false);

  // Live search with debounce
  useEffect(() => {
    const timer = setTimeout(async () => {
      if (searchTerm.trim()) {
        setLoading(true);
        setSearched(true);
        try {
          const response = await axios.get(
            `${process.env.REACT_APP_API_URL}/auth/search?username=${searchTerm}`
          );
          setResults(response.data);
        } catch (error) {
          console.error('Search error:', error);
          setResults([]);
        } finally {
          setLoading(false);
        }
      } else {
        setResults([]);
        setSearched(false);
      }
    }, 300);

    return () => clearTimeout(timer);
  }, [searchTerm]);

  const handleSearch = (e) => {
    e.preventDefault();
    // Search is now live, just prevent form submission
  };

  return (
    <div className="search-container">
      <form onSubmit={handleSearch} className="search-form">
        <div className="search-wrapper">
          <input
            type="text"
            placeholder="🔍 Search by username..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="search-input-field"
          />
          <button 
            type="submit" 
            disabled={loading}
            className="search-submit-btn"
          >
            {loading ? '⏳ Searching...' : '🔍 Search'}
          </button>
        </div>
      </form>

      {searched && (
        <div>
          <h3 className="search-results-header">
            {loading ? 'Searching...' : `Found ${results.length} results`}
          </h3>
          
          {results.length > 0 ? (
            <div style={{display: 'grid', gap: '1rem'}}>
              {results.map(user => (
                <div 
                  key={user._id}
                  className="search-user-card"
                  onClick={() => navigate(`/profile/${user._id}`)}
                >
                  <div className="search-user-avatar">
                    {user.profilePicture ? (
                      <img 
                        src={`http://localhost:5000${user.profilePicture}`} 
                        alt={user.username}
                        style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '50%' }}
                      />
                    ) : (
                      <>{user.firstName?.charAt(0)}{user.lastName?.charAt(0)}</>
                    )}
                  </div>
                  <div className="search-user-info">
                    <div className="search-user-name" style={{display: 'flex', alignItems: 'center', gap: '0.5rem'}}>
                      {user.icon && (
                        <img 
                          src={`http://localhost:5000${user.icon}`} 
                          alt="icon"
                          style={{
                            width: '20px',
                            height: '20px',
                            borderRadius: '50%',
                            objectFit: 'cover',
                            backgroundColor: 'transparent'
                          }}
                        />
                      )}
                      <span style={{color: user.nicknameColor || '#ffffff'}}>
                        {user.firstName} {user.lastName}
                      </span>
                      {user.badge && <span style={{fontSize: '0.9rem'}}>{user.badge}</span>}
                      {user.isVerified && ' ✅'}
                    </div>
                    <div className="search-user-username">@{user.username}</div>
                    {user.bio && <div style={{color: '#999', margin: '0.25rem 0 0 0', fontSize: '0.9rem'}}>{user.bio}</div>}
                    <div style={{color: '#1dd1a1', margin: '0.5rem 0 0 0', fontSize: '0.85rem'}}>
                      👥 {user.followers?.length || 0} followers
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            !loading && <p style={{color: '#999', textAlign: 'center'}}>No users found</p>
          )}
        </div>
      )}
    </div>
  );
};

export default Search;
